import React, { useState } from "react";
import {
  checkHasLowerLetter,
  checkHasNumber,
  checkHasSpecial,
  checkHasUpperLetter,
} from "../../utils/commonFunctions";
import { HidePassword, ViewPassword } from "../Icon";
import PasswordValidationCard from "../commons/PasswordValidationCard/PasswordValidationCard";
import "./SignUpCard.scss";
import {
  PasswordValidationType,
  UserDetailsType,
  UserProfileDetailErrorType,
} from "./SignUpCard";
import { BusinessInformationIcon, BusinessInformationRedIcon, CreateAccountIcon, PasswordSettingIcon, PasswordSettingRedIcon, PersonalInformationIcon, PersonalInformationRedIcon, ProjExelLogo } from "../../assets/images";

type AppProps = {
  onNext: any;
  onPrevious: any;
  userProfileDetailsError: any;
  setUserProfileDetailsError: React.Dispatch<
    React.SetStateAction<UserProfileDetailErrorType>
  >;
  inputDetails: UserDetailsType;
  setInputDetails: React.Dispatch<React.SetStateAction<UserDetailsType>>;
  email: string;
  handleEmailChange: (data: any) => void;
  password: string;
  newPassword: string;
  passwordPopUpShow: boolean;
  passwordValidation: PasswordValidationType;
  setPasswordPopUpshow: React.Dispatch<React.SetStateAction<boolean>>;
  setPasswordValidation: React.Dispatch<
    React.SetStateAction<PasswordValidationType>
  >;
  isEmail:number | null;
  emailMessage:null|string;
  emailFetching:boolean;
  activeStep:number;

};
const PasswordDetails = ({
  onNext,
  onPrevious,
  userProfileDetailsError,
  setUserProfileDetailsError,
  inputDetails,
  setInputDetails,
  email,
  handleEmailChange,
  password,
  newPassword,
  passwordPopUpShow,
  passwordValidation,
  setPasswordPopUpshow,
  setPasswordValidation,
  isEmail,
  emailMessage,
  emailFetching,
  activeStep
}: AppProps) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showNewPassword, setShowNewPassword] = useState<boolean>(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const toggleShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };


  const handleChangeNewPassword = (e: any) => {
    setPasswordPopUpshow(true);
    let removeSpace = e?.target?.value.replace(/\s+/g, "");

    setInputDetails((prevDetails: any) => ({
      ...prevDetails,
      passworDetails: {
        ...prevDetails.passworDetails,
        password: removeSpace,
      },
    }));

    setUserProfileDetailsError((prv: any) => ({
      ...prv,
      newPasswordAgainError: "",
    }));

    let specialCharacterValue = checkHasSpecial(e.target.value);
    let uppercaseLetterValue = checkHasUpperLetter(e.target.value);
    let lowercaseLetterValue = checkHasLowerLetter(e.target.value);
    let numbercaseLetterValue = checkHasNumber(e.target.value);

    setPasswordValidation((prev: any) => ({
      ...prev,
      ...(!!specialCharacterValue && { special: true }),
      ...(!!uppercaseLetterValue && { upperCase: true }),
      ...(!!lowercaseLetterValue && { lowerCase: true }),
      ...(!!numbercaseLetterValue && { number: true }),
      ...(!!(e.target.value.length >= 8) && { atLeast: true }),
      ...(!specialCharacterValue && { special: false }),
      ...(!uppercaseLetterValue && { upperCase: false }),
      ...(!lowercaseLetterValue && { lowerCase: false }),
      ...(!numbercaseLetterValue && { number: false }),
      ...(!(e.target.value.length >= 8) && { atLeast: false }),
    }));
  };

 const steps = [
     {
       icon: CreateAccountIcon,
       redIcon: CreateAccountIcon,
     
     },
     {
       icon: PersonalInformationIcon,
       redIcon: PersonalInformationRedIcon,
     
     },
     {
       icon: BusinessInformationIcon,
       redIcon: BusinessInformationRedIcon,
     
     },
     {
       icon: PasswordSettingIcon,
       redIcon: PasswordSettingRedIcon,
    
     },
   ];

  return (
    <>
      <div
        className="main-signup"
      >
        <div className="password-info-container">
          <div className="logo-section mb-3">
          <img src={ProjExelLogo}   className="company-logo"/>
          <div style={{display:'flex',marginBottom:'30px'}}>
          {steps?.map((step, index) => (
          < >
          
                        <div  key={index} className="step-indicator">
                          <span
                            className={`step${
                              activeStep === index ? "active" : ""
                            }`}
                          >
                            <img
                              src={
                                activeStep === index || activeStep > index
                                  ? step?.redIcon
                                  : step?.icon
                              }
                              alt={' Icon'}
                              // className="left-pannel-image"
                            />
                          </span>
                          <span className="line"></span>
                        </div>
                      
                      </>
                      
                    ))}
                    </div>
                    
                            </div>
         
          <h5 className="mt-4 right-panel-heading">Set Your Password</h5>
          <span className="right-panel-subHeading">
            Enter your details below to get started.
          </span>
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="foldername">
                  Email<span className="color-red">*</span>
                </label>
                <div style={{position:'relative'}}>
                <div
                className="row"
          
          >
            <div className="col-md-12">
                <input
                  type={"text"}
                  className={`form-control mb-1 ${
                    !!userProfileDetailsError?.emailError
                      ? "error-border"
                      : null
                  }`}
                  name="text"
                  value={email}
                  autoFocus
                  onChange={handleEmailChange}
                  maxLength={60}
                />
                </div>
          
                </div>
                {/* commented for testing */}
                {
                       emailFetching && inputDetails?.passworDetails?.email &&
                        (
              <div style={{position:"absolute", top:"0", right:'0'}}> 
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  style={{
                    margin: "auto",
                    background: "none",
                    display: "block",
                    shapeRendering: "auto",
                  }}
                  width={40}
                  height={40}
                  viewBox="0 0 100 100"
                  preserveAspectRatio="xMidYMid"
                >
                  <circle
                    cx="50"
                    cy="50"
                    fill="none"
                    stroke="#dd4433"
                    stroke-width="5"
                    r="20"
                    stroke-dasharray="94.24777960769379 33.41592653589793"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      repeatCount="indefinite"
                      dur="1s"
                      values="0 50 50;360 50 50"
                      keyTimes="0;1"
                    ></animateTransform>
                  </circle>
                </svg>
              </div>
            )}
            </div>
            
                {!!userProfileDetailsError?.emailError && (
                  <small className="text-danger">
                    {userProfileDetailsError?.emailError}
                  </small>
                )}
                    {inputDetails?.passworDetails?.email &&
        isEmail === 1 &&
        emailMessage?.includes("email") ? (
          <small
            className="text-danger"
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            Email is already in use!
          </small>
        ) : (
          ""
        )}
                <div className="row mt-1">
                  <div className="col-md-12">
                    <label>
                      Password<span className="color-red">*</span>
                    </label>
                    <div className="d-flex flex-row position-relative">
                      <input
                      style={{paddingRight:'36px'}}
                        type={showPassword ? "text" : "password"}
                        className={`form-control mb-3 ${
                          !!userProfileDetailsError?.newPasswordError
                            ? "error-border"
                            : null
                        }`}
                        autoComplete="new-password"
                        name="password"
                        value={password}
                        onChange={(e) => {
                          handleChangeNewPassword(e);
                        }}
                      />
                      <div
                        className="icon-box"
                        style={{ top: "7px" }}
                        onClick={toggleShowPassword}
                      >
                        {showPassword ? <ViewPassword /> : <HidePassword />}
                      </div>
                      {password?.length &&
                      passwordPopUpShow &&
                      Object.values(passwordValidation).includes(false) ? (
                        <PasswordValidationCard
                          className={"tooltext-right-signup  position-absolute"}
                          triangleClassName={"triangle-right-signup position-absolute"}
                          isLeast={passwordValidation?.atLeast}
                          isUpperCase={passwordValidation?.upperCase}
                          isLowerCase={passwordValidation?.lowerCase}
                          isSpecial={passwordValidation?.special}
                          isNumber={passwordValidation?.number}
                        />
                      ) : (
                        ""
                      )}
                      {!!userProfileDetailsError?.newPasswordError && (
                        <small className="text-danger">
                          {userProfileDetailsError?.newPasswordError}
                        </small>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row mt-1">
                  <div className="col-md-12">
                    <label>
                      Password Again<span className="color-red">*</span>
                    </label>
                    <div className="d-flex flex-row position-relative">
                      <input
                         style={{paddingRight:'36px'}}
                        type={showNewPassword ? "text" : "password"}
                        className={`form-control mb-1 ${
                          !!userProfileDetailsError?.newPasswordAgainError
                            ? "error-border"
                            : null
                        }`}
                        value={newPassword}
                        onChange={(e) => {
                          let removeSpace = e?.target?.value.replace(
                            /\s+/g,
                            ""
                          );
                          setUserProfileDetailsError((prv: any) => ({
                            ...prv,
                            newPasswordAgainError: "",
                          }));
                          setInputDetails((prevDetails: any) => ({
                            ...prevDetails,
                            passworDetails: {
                              ...prevDetails.passworDetails,
                              newPassword: removeSpace,
                            },
                          }));
                        }}
                      />
                      <div
                        className="icon-box"
                        style={{ top: "7px" }}
                        onClick={toggleShowNewPassword}
                      >
                        {showNewPassword ? <ViewPassword /> : <HidePassword />}
                      </div>
                    </div>
                    {!!userProfileDetailsError?.newPasswordAgainError && (
                      <small className="text-danger">
                        {userProfileDetailsError?.newPasswordAgainError}
                      </small>
                    )}
                  </div>
                </div>
                <div
                  className="mb-3 mt-3 d-flex"
                  style={{ float: "inline-start" }}
                >
                  <button
                    type="submit"
                    className="btn btn-outline"
                    style={{ width: "94px" }}
                    onClick={onPrevious}
                  >
                    Back
                  </button>
                </div>

                <div
                  className="mb-3 mt-3 d-flex"
                  style={{ float: "inline-end" }}
                >
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ width: "94px" }}
                    disabled={Object.values(passwordValidation).includes(false) || !newPassword ||!password || userProfileDetailsError?.emailError ||   isEmail === 1 }
                    onClick={onNext}
                    tabIndex={0}
                  >
                    Finish
                  </button>
                </div>
              </div>
            </div>
          </form>
          <p className="mobileCopyright">
                &copy; Copyright 2025 | AKSSAI ProjExel | All right reserved
              </p>
        </div>
      </div>
    </>
  );
};

export default PasswordDetails;
